const server = {
    'url': 'https://superyylt.com/'
    // 'url':'http://cj.com/'
    
}

export  default server
